document.addEventListener('DOMContentLoaded', () => {


// バーガーメニュー(main)
window.initHamburgerMenu({
  btnSelector: '.js-gNav__btn',
  targetSelector: '.js-gNav__target',
  activeClass: 'is-active',
  fixedClass: 'is-fixed',
  breakpoint: 991,
});
// アコーディオン(main)
window.initCollapse({
  parentSelector: '.js-accordion',
  btnSelector: '.js-accordion__btn',
  hoverSelector: '.js-accordion__none',
  targetSelector: '.js-accordion__target',
  activeClass: 'is-active',
  mediaType: 'max',
  breakpoint: 9999,
  isFade: false,
  idPrefix: 'accordion',
});
// ドロップダウンナビ(main)
window.initCollapse({
  parentSelector: '.js-dropdown',
  btnSelector: '.js-dropdown__btn',
  hoverSelector: '.js-dropdown__hover',
  targetSelector: '.js-dropdown__target',
  activeClass: 'is-active',
  mediaType: 'min',
  breakpoint: 0,
  isFade: false,
  idPrefix: 'dropdown',
});
// タブメニュー(main)
window.initTabs({
  parentSelector: '.js-tab',
  btnSelector: '.js-tab__btn',
  targetSelector: '.js-tab__target',
  activeClass: 'is-active',
  idPrefix: 'tab',
  dataKey: 'tab', // data-tab を使う
});

// モーダル(main)
window.initModal({
  parentSelector: '.js-modal',
  btnSelector: '.js-modal__btn',
  targetSelector: '.js-modal__target',
  activeClass: 'is-active',
  fixedClass: 'is-fixed',
  idPrefix: 'modal',
});

// ツールチップ(main)
window.initTooltip({
  parentSelector: '.js-tooltip',
  targetSelector: '.js-tooltip__target',
  attrName: 'data-tooltip',
  activeClass: 'is-active',
  idPrefix: 'tip',
});

// 画像遅延読み込み(main)
window.initLazyLoad({
  targetSelector: '.js-lazy',
  rootMargin: '0px 0px 200px 0px', // 200px手前で読み込み開始
  activeClass: 'is-loaded',
});

// スムーススクロール(main)
window.initSmoothScroll({
  offset: 0,
  speed: 600,
});
// スクロールトリガー(main)
window.initScrollTrigger({
  targetSelector: '.js-scroll',
  activeClass: 'is-show',
  positionTop: -0.2,
  positionBottom: -0.2,
  once: false,
});
// スクロールジャッジ(main)
window.initScrollJudgement({
  scrollPosition: 100,
  targetSelector: '.js-header',
  activeClass: 'is-scrolled',
  upClass: 'is-up',
  downClass: 'is-down',
  scrollingUpClass: 'is-scrolling-up',
  scrollingDownClass: 'is-scrolling-down',
  scrollingDelayTime: 800,
});



// スライダー(main)
window.initSwiperSlider({
  wrapperSelector: '.js-sliderFrontMv',
  sliderSelector: '.slider',
  effect: 'slide',
  speed: 1000,
  autoplayDelay: 4000,
});

// ギャラリー(商品詳細)
window.initSwiperGallery({
  wrapperSelector: '.js-productGallery',
  mainSelector: '.js-productMainSlider',
  thumbsSelector: '.js-productThumbs',
  thumbItemSelector: '.js-productThumbs__item',
  effect: 'fade',
  speed: 600,
});


// 関連商品(商品詳細)
window.initProductRecommendations({
  selector: '.js-productRecommendations',
});

// フォーム 添付ファイル(main)
window.initFormFileInputs({
  wrapperSelector: '.js-formFile__wrapper',
  fileInputSelector: '.js-formFile__input',
  resetSelector: '.js-formFile__reset',
  nameSelector: '.js-formFile__name',
  changedClass: 'is-selected',
  emptyText: '選択されていません',
});

// プルプル
window.initPulpul({
  targetSelector: '.js-pulpul',
  rangeX: 6,
  rangeY: 6,
  intervalMin: 50,          // 1フレームの最短時間 (ms)
  intervalMax: 100,         // 1フレームの最長時間 (ms)
  shakeDurationMin: 1500,    // 振動し続ける最短時間 (ms)
  shakeDurationMax: 2000,   // 振動し続ける最長時間 (ms)
  pauseMin: 2000,
  pauseMax: 5000,
});

// スクロールヒント
new ScrollHint(".js-scrollhint");




});